module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_07-7a22fbabb7d37eeac2b1d7f86d98d3a8.jpg";